const Footer = () => {
  return (
    <footer className="footer">
      <span>
        &copy; {new Date().getFullYear()} Ministry of Local Government
      </span>
      <div className="footer-links">
        <a href="#">Privacy</a>
        <a href="#">Policy</a>
      </div>
      <span>Produced by MWETANA</span>
    </footer>
  );
};

export default Footer;
